require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-2018-a-new-beginning.json") })
        }
      }, "path---posts-2018-a-new-beginning");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-2018-a-new-beginning!./.cache/json/posts-2018-a-new-beginning.json
// module id = 330
// module chunks = 231608221292675